/* src/app/common/components/login-modal/login-modal.component.scss */
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  display: none !important;
}
/*# sourceMappingURL=login-modal.component-W2PK5D4Y.css.map */
